var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStressViewEnries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#febe10;}.cls-2{fill:#ffd77d;}.cls-3{fill:#fffbc5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stress_view_enries") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_94_copy",
    "data-name": "Layer 94 copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "litter_expenses_view_entries",
    "data-name": "litter expenses view entries"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.86.62a16.94,16.94,0,0,0-17,16.87V428.34a17,17,0,0,0,17,16.87H582.74a17,17,0,0,0,17-16.87V17.49a16.94,16.94,0,0,0-17-16.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.79,
    y: 76.76,
    width: 380.92,
    height: 444.6,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382,270.83V582.57a17,17,0,0,1-17.26,16.72H18.29A17,17,0,0,1,1,582.57V171.41a17,17,0,0,1,17.25-16.72H262.08a17.67,17.67,0,0,1,5.85,1L380.4,263.9A16.4,16.4,0,0,1,382,270.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.19,262.9h-95a17.21,17.21,0,0,1-17.43-17V154.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.44,
    y: 371.38,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.92 1.41) rotate(-0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.55,
    y: 516.96,
    width: 133.73,
    height: 36.28,
    rx: 12,
    transform: "translate(-4.01 0.94) rotate(-0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.87,
    y: 298.83,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.37 1.4) rotate(-0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.99,
    y: 443.93,
    width: 261.46,
    height: 36.28,
    rx: 12,
    transform: "translate(-3.46 1.41) rotate(-0.43)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressViewEnries);
export default __webpack_public_path__ + "static/media/stress_view_enries.ba3d0d4b9183f3b28414604cae594bd6.svg";
export { ForwardRef as ReactComponent };